import { NavLink } from "react-router-dom";
import { useTheme } from "../../components/context/context"
import { Typography } from "@mui/material";
import './style.css'
export default function Footer() {
    const { fontSize } = useTheme();
    return (
        <div style={style.footerContainer}>
            <header style={style.header}>
                <NavLink to="/terms-of-use" style={style.headerLinks}>
                    Terms of use
                </NavLink>
                <span style={{ margin: "5px" }}>|</span>
                <NavLink to="/statement" style={style.headerLinks}>
                    Accessibility Statement
                </NavLink >
                <span style={{ margin: "5px" }}>|</span>
                <NavLink to="/help" style={style.headerLinks}>
                    Help
                </NavLink>
            </header>
            <div style={style.body}>
                <Typography variant="7">
                    Site Designed, Developed and Hosted by the National Informatics Centre, Meghalaya State Centre, Shillong.
                    Contents Owned, Maintained and Updated by the Meghalaya Society for Social Audit and Transparency (MSSAT).
                    Last updated on December 6, 2023
                </Typography>
            </div>
        </div>
    )
}

const style = {
    footerContainer: {
        backgroundColor: "rgb(6, 1, 98)",
        minHeight: "50px",
        marginTop: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop:"10px"

    },
    header: {
        color: "white",
    },
    headerLinks: {
        color: "white"
    },
    body: {
        margin: "10px",
        textAlign: "center",
        width: "80%",
        color: "white"
    }
}